
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff",
      function () {
        return require("private-next-pages/staff/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff"])
      });
    }
  